function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.7125 2.41305C7.4875 0.93584 4.39901 0.263142 2.09405 0.0114375C0.941244 -0.114449 0 0.815847 0 1.96364V13.3941C0 14.5419 0.941244 15.4725 2.09405 15.5984C4.39901 15.8501 7.4875 16.5228 9.7125 18V2.41305ZM11.2875 18C13.5125 16.5228 16.601 15.8501 18.906 15.5984C20.0588 15.4725 21 14.5419 21 13.3941V1.96364C21 0.815847 20.0588 -0.114449 18.906 0.0114375C16.601 0.263142 13.5125 0.93584 11.2875 2.41305V18ZM2.37176 5.21555C2.43832 4.8002 2.84071 4.51563 3.27051 4.57996C4.63842 4.78468 6.17893 5.12687 7.63401 5.67065C8.03966 5.82224 8.24134 6.26292 8.08448 6.65493C7.92761 7.04695 7.4716 7.24185 7.06595 7.09026C5.74438 6.59638 4.31968 6.27718 3.02946 6.08408C2.59966 6.01976 2.3052 5.6309 2.37176 5.21555ZM3.27051 8.63878C2.84071 8.57445 2.43832 8.85902 2.37176 9.27437C2.3052 9.68972 2.59966 10.0786 3.02946 10.1429C3.67967 10.2402 4.36602 10.3699 5.05734 10.5384C5.47905 10.6412 5.90716 10.3942 6.01356 9.98667C6.11995 9.57913 5.86434 9.16541 5.44263 9.06259C4.69817 8.88108 3.96323 8.74245 3.27051 8.63878Z"
});

var SvgAdviceFill = function SvgAdviceFill(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAdviceFill, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/advice-fill.8730fa61.svg";
export { ForwardRef as ReactComponent };